/**
 * Created by chengpanwang on 2017/11/27.
 */
var TableStyle = {
  install (Vue) {
    Vue.prototype.$tableStyle = TableStyle
  },
  dateTimeWidth: 120,
  dateWidth: 100,
  dateMinuteWidth: 130
}

export default TableStyle



// WEBPACK FOOTER //
// ./src/plugins/TableStyle.js